// src/lib/queryClient.ts
import { QueryClient } from '@tanstack/react-query';
import { setupQueryPerformanceMonitoring } from '../utils/queryPerformanceMonitor';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30秒（表示は即時、30秒後に再取得可能）
      gcTime: 10 * 60 * 1000,   // 10分（同一セッション内で再利用しやすく）
      retry: 1,
      refetchOnWindowFocus: true, // タブ切り替え時にバックグラウンド更新
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

// パフォーマンス監視をセットアップ
setupQueryPerformanceMonitoring(queryClient);
